import { render } from "../templates/scenario-benefits-filter.html?vue&type=template&id=0494b97c"
import script from "./scenario-benefits-filter.vue?vue&type=script&lang=js"
export * from "./scenario-benefits-filter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__